import { Component } from '@angular/core';

@Component({
    selector: 'finder-dine-to-finder-error-modal',
    templateUrl: './dine-to-finder-error-modal.component.html',
    styleUrls: ['./dine-to-finder-error-modal.component.scss']
})
export class DineToFinderErrorModalComponent {

    data: any;

    constructor() { }

}
